.avatarName {
  display: flex;
  gap: 12px;
}

.avatarName > div {
  display: flex;
  flex-direction: column;
}

.profileName {
  margin-block: auto;
}

.profileHandle {
  color: #444;
}

.profileHandle:not(.profileName ~ *) {
  margin-block: auto;
}

.website::before {
  content: '🔗';
  margin-inline-end: 4px;
}
